import { render, staticRenderFns } from "./CustomerWMSMappings.vue?vue&type=template&id=59033f68"
import script from "./CustomerWMSMappings.vue?vue&type=script&lang=js"
export * from "./CustomerWMSMappings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports